<template>
		<div class="contents">
			<h3 class="mark">
				<div class="type">
					<span>
						<img src="../assets/result-detail-output-icon01.svg" alt="*" />あなたのアウトプット性質
					</span>
				</div><!-- end .type -->
				<div class="cover">
					創出型{{outputResult.percentageLeft}}%、操縦型{{outputResult.percentageRight}}%
				</div><!-- end .cover -->
			</h3><!-- end .mark -->
			<div class="sentence">	
				<div class="catch">
					<span class="left">
						Detailed
					</span>
					<span class="right">
						explanation
					</span>
				</div><!-- end .catch -->		
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->	
				<h2>アウトプットの質を高めることで、これからますますクリエイティブな才能を発揮していく</h2>
				<img src="../assets/result-detail-output-inleft01.svg" alt="*" class="visual" />
				<div class="caption">
					アウトプットに挑戦し続けることで、あなたが想像する以上に、あなたは遥かに大きく成長する
				</div><!-- end .caption -->
				<p>この項目では、あなたのアウトプットの経験値や能力について検査しました。内向度が高いあなたは、アウトプットを繰り返すことが生きがいとなり、ストレスの発散に繋がります。</p>
				<p>なぜなら、内向度が高いあなたは、心や脳に溜め込むものが非常に多いからです。だから、想いやアイデアを吐き出すことで、心や脳がすっきりし、達成感を得られ、それがあなたの幸福度を高めるのです。</p>
				<p>あなたは、創出型{{outputResult.percentageLeft}}%と、豊かなアウトプットの体験を重ねていることが分かりました。あなたは座学の時間を取らずとも、日ごろからいろんなものを感受しています。良い意味であなたは外向的な人や内向度が低～中度の人よりも、アウトプットできる材料の質が良い可能性を秘めています。内向性を活用し、アイデアや精神性をアウトプットしていくようなクリエイティブな分野では大いに活躍できるはずです。</p>
				<p>また、このタイプの人は、アウトプットすればするほど、その質がどんどん磨かれていきます。ですから、自分の人生において、「一生アウトプットについてこだわていく」と覚悟するのも良いでしょう。</p>
				<p>今回の診断では、創出型{{outputResult.percentageLeft}}%となっていますが、これから創出型のスコアを高くなるように、これからもレベルを上げたアウトプットを取り組んでいくようにしてみて下さい。</p>
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->	
				<h2>あなたは一度知りさえすれば、とても大きな心の余裕を掴むことができる</h2>
				<img src="../assets/result-detail-output-inleft02.svg" alt="*" class="visual" />
				<div class="caption">
					内向的な人間にとって、既に知っていることを増やすことは、自身のメンタルをとても強くしてくれる
				</div><!-- end .caption -->
				<p>あなたの特性を引き上げる重要なキーワードは「既知」です。あなたは一度知りさえすれば、一度体験しさえすれば、次に同様のことをする際は、大きな余裕を積み上げることができます。</p>
				<p>内向度が高く、他へ(外へ)意識が向くということは、一度の学習や経験で、周囲の人と比べて非常に深く多く吸収することができます。自身の偏ったパターンに埋没するよりかは、他人のペースに戦略的に巻き込れてみたり、新しい分野を掘り下げてみたりすることで、自然に既知レベルは上がり、あなたの心の余裕に繋がります。</p>

				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->	
				<h2>まずは自分事で忙しくなり、自身のスキルや能力に繋がる「既知」に力を注ごう</h2>
				<img src="../assets/result-detail-output-inleft03.svg" alt="*" class="visual" />
				<div class="caption">
					知識やスキルが増えれば、自然にあなたは自分の内向性をフル活用し、様々なアウトプットを自然に展開していくはずだ
				</div><!-- end .caption -->
				<p>一番の解決方法は、本当に好きなことを見つけ、没頭し、自分の軸を作るということ。あなたは好きなことに関しては、高い内向性で主体的かつ哲学的に行動を取ることができます。</p>
				<p>自分の好きな自分事で忙しくなってしまえば、他人との無駄な接触機会が減り、本当に必要な関わりだけを獲得します。キーパーソンの意見に流されたり、素敵な人に任せたりすることが増えれば、流されやすい、他人任せといった個性はもはや強みにしかなりません。</p>
				<p>このように、あなたの内向性は、自身の潜在意識の癖を上手に利用するだけで、人生を大きく上昇させることができるのです。</p>
			</div><!-- end .sentence -->
		</div><!-- end .contents -->			
</template>

<script>


export default {
	name: 'ResultDetailOutputInLeft',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},		
		// output
		outputResult:function(){
			return this.$store.getters.outputResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
